import React,{useState, useEffect} from 'react';
import { Helmet } from "react-helmet";
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'


function Jhist(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  
return(
    <div>
       <Sides/>
  <Helmet>
 
  <title>Master the Art of Java History: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java history tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java history,javascript history,java version history,javascript history back
,history of java programming language,java language history,Java break,Java Comment,Java Constructor,Java Control Structor Statement,Java Datatype,Java for loop, Java argument,Java Function,java method,Java Function Override,Java Function Overloading,Java Identifier,Java Home,Java If,Java ifelse,Java if else if,Java inheritance,Java input,Java Keyword,Java literal,Java loop,Java Object and class,Java oops,Java operator,Java Search,JavaJava String,Java Type variable,Java variable,Java While,Java user defined function,Java Passing argument,Java single inheritance,Java object initialization,Java namespace,Java Multi level inheritance,Java introduction,Java goto,Java basic progrsmming,Java basic Programming Language,Java data type,Java control structer statement,Java continue,Java conditional operator,Java comment,Java array " />
<link rel="canonical" href="https://www.codeexampler.com/java-history" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">What is the history of java programming?</h1>

    <div className="first">
    <a href="/java-enum">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-features"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

<p className="mt-4 para">1, Java is a powerful high-level object-oriented programming language and java developed  by James Gosling in 1995 by Sun Microsystems,
     Inc and after launched java in the market caused a revolution in programming And 
java  programming language impact was rapid<br/><br/>
2, It can be executed on multiple platforms like windows, mac os, Linux, Unix, etc.<br/><br/>
3, Java is related to Java,c++ .this is direct proceeding by c
Means java derives int syntax from c.  <br/>
</p>
  <h1 className="mt-5">  </h1>
     
  <div className="back">
  <a href="/java-enum">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-features">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jhist;